<template>
  <v-dialog
      v-model="get_dialogReport.show"
      width="500"
    >

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ get_dialogReport.tittle }}
        </v-card-title>

        <v-card-text>
          <v-row>
    <v-col
      cols="12"
      sm="6"
      md="6"
    >
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            locale="es"
            label="Fecha inicial"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          @input="menu2 = false"
          min="1950-01-01"
          locale="es"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-spacer></v-spacer>
    <v-col
      cols="12"
      sm="6"
      md="6"
    >
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="datefin"
            locale="es"
            label="Fecha final"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="datefin"
          @input="menu2 = false"
           min="1950-01-01"
           locale="es"
        ></v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="actionDialogoFechas"
          >
            Descargar
          </v-btn>
        </v-card-actions>
            <v-progress-linear
              :active="progressbar"
              :indeterminate="true"
              absolute
              bottom
              color="blue darken-2 accent-4">
            </v-progress-linear>
      </v-card>
    </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import XLSX from 'xlsx'
export default {
  props: ['dialog2'],
  computed: {
    ...mapGetters(['get_dialogReport', 'get_report'])
  },
  data () {
    return {
      tipoRpt: 'general',
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      datefin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      progressbar: false,
      dialog: true
    }
  },
  methods: {
    ...mapActions(['urlGetData', 'getUrExportDataServerAction']),
    async actionDialogoFechas () {
      this.progressbar = true
      let url = this.get_dialogReport.urloption
      url = url.replace('{fini}', this.date).replace('{ffin}', this.datefin)
      if (this.get_dialogReport.type === 'xlsx') {
        const itemsX = await this.urlGetData(url)
        const nombre = this.get_dialogReport.tittle
        this.progressbar = false
        const data = XLSX.utils.json_to_sheet(itemsX)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, data, 'data')
        XLSX.writeFile(wb, `${nombre}.xlsx`)
      }
      if (this.get_dialogReport.type === 'zip') {
        this.getUrExportDataServerAction({ url: url, data: { folio: 'facturas' } })
        this.progressbar = false
      }
    }
  }
}
</script>

<style>
</style>
